import { debounce } from 'lodash'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { AvatarFile } from '../components/AvatarFile'
import { ColorPicker } from '../components/ColorPicker'
import { Fonts } from '../components/Fonts'
import { Input } from '../components/Input'
import { PreviewBlock } from '../components/Links/previewBlock'
import { TextArea } from '../components/TextArea'
import { ThemesRadioGroup } from '../components/Themes'
import { getDesign, updateDesign } from '../services/design'
import { RootState } from '../store'
import { getPageInfo } from '../services/userProfile'
import UploadImageModal from '../components/UploadImageModal/UploadImageModal'
import { ModalWrapper } from '../modals/ModalWrapper'
import CropperComponent from '../components/Cropper'
import { uploadPageImg, removePageImg } from '../services/page'
import { toast } from 'react-toastify'

export const Design = () => {
  const [designImg, setDesignImg] = useState<string>()

  const {
    user: { data: user },
  } = useSelector((state: RootState) => state.userReducer)
  const { t } = useTranslation()
  const methods = useFormContext<DesignFormFields>()
  const [showModal, setShowModal] = useState(false)
  const [counter, setCounter] = useState(0)
  const {
    register,
    watch,
    reset,
    formState: { errors, defaultValues },
  } = methods

  const fetchDesignData = async () => {
    try {
      const design = (await getDesign()) as Design

      const page = await getPageInfo(user?.username)

      // TODO: only to test until there are stored fonts
      if (design) {
        setDesignImg(page.pages[0].avatar)
        reset({
          title: design.title || '',
          bio: design.bio || '',
          theme_id: design?.theme?.id || 1,
          font_id: design?.font?.id || 1,
          fontColor: design.fontColor || '#5ac8fa',
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  const uploadImageSuccess = (data: any) => {
    setShowModal(false)
    setDesignImg(data)
    console.log(data)
  }

  const removeImage = async () => {
    removePageImg()
    setDesignImg('')
    toast.success('Image removed successfully')
  }

  useEffect(() => {
    fetchDesignData()
  }, [])

  const debouncedCb = debounce((formValue) => {
    updateDesign(formValue)
  }, 1000)

  useEffect(() => {
    const subscription = watch(debouncedCb)
    return () => subscription.unsubscribe()
  }, [watch])

  return (
    <div className="flex flex-col sm:flex-row">
      <div
        className="flex flex-col overflow-scroll px-10 pb-10 pt-5 sm:top-0 sm:ml-[100px] sm:w-[50%]"
        style={{ height: 'calc(100vh - 89px)' }}
      >
        <div className="mx-auto mb-8 w-full md:mb-0">
          <form className="w-full">
            <div className="mx-auto mb-6 w-[100px]">
              <div onClick={() => setShowModal(true)}>
                <AvatarFile avatarUrl={designImg || null} />
              </div>
              {designImg && (
                <p
                  onClick={() => removeImage()}
                  className="cursor-pointer text-center text-red-500"
                >
                  {t('delete')}
                </p>
              )}
            </div>

            <Input
              variant={errors.title ? 'danger' : 'third'}
              placeholder={t('profileTitle')}
              type="text"
              helperText={errors.title?.message as string}
              {...register('title')}
            />
            <TextArea
              variant={errors.bio ? 'danger' : 'third'}
              placeholder={t('bio')}
              helperText={errors.bio?.message as string}
              {...register('bio')}
            />

            <ThemesRadioGroup subscription={user?.subscription} />

            <Fonts variant="primary" subscription={user?.subscription} />

            <ColorPicker
              {...register('fontColor')}
              currentColor={watch().fontColor || '#5ac8fa'}
            />

            <ModalWrapper
              showModal={showModal}
              onClose={() => setShowModal(false)}
            >
              <div className="p-4">
                <CropperComponent
                  uploadImage={uploadPageImg}
                  successCallback={uploadImageSuccess}
                />
              </div>
            </ModalWrapper>
          </form>
        </div>
      </div>

      <div
        className="hidden w-[50%] items-center sm:flex"
        style={{ height: 'calc(100vh - 89px)' }}
      >
        <PreviewBlock />
      </div>
    </div>
  )
}
